import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import React from 'react';
import classNames from 'classnames';
import Popup from './Popup';
export var NavTooltip = function NavTooltip(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottom right' : _ref$position,
      props = _objectWithoutProperties(_ref, ["className", "children", "position"]);

  return /*#__PURE__*/React.createElement(Popup, _extends({
    className: classNames('cloud-ui-nav-tooltip', className),
    on: "hover",
    position: position
  }, props), children);
};
export default NavTooltip;